import { format } from "date-fns"
import { useTranslation } from "react-i18next"
import InfoNotificationIcon from "@/assets/icons/notifications/info-notification-icon.tsx"
import { cn } from "@/utils/styles.ts"

interface Props {
  reset_date?: string
  remaining?: number
}

export const LimitWidget: React.FC<Props> = ({ reset_date, remaining }) => {
  const { t } = useTranslation()

  const getClassNames = () => {
    const base =
      "grid w-full grid-cols-[30px_auto] items-center gap-3 rounded-sm bg-red-200 p-4 text-[14px] font-medium text-red-700"

    return cn(base, remaining && "bg-amber-500/20 text-amber-700")
  }

  return (
    <div className={getClassNames()}>
      <InfoNotificationIcon
        size={30}
        color={reset_date ? "rgb(185 28 28)" : "rgb(180 83 9)"}
      />
      {reset_date && (
        <p>
          {t("messageRateLimitExceeded")} {t("limitWillBeRenewedIn")}{" "}
          <span className="font-semibold">
            {format(new Date(reset_date), "dd.MM.yyyy")}
          </span>
        </p>
      )}
      {remaining && (
        <p>
          {t("youStillHave")} <span className="font-semibold">{remaining}</span>{" "}
          {remaining > 1
            ? t("messagesLeftThisMonth")
            : t("messageLeftThisMonth")}{" "}
        </p>
      )}
    </div>
  )
}
